import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Outlet, Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase-config/firebase'



const NavBar = () => {

    return (
        <>
            <Navbar expand="lg" variant="dark" >
                <Container>
                    <Navbar.Brand as={Link} to="/">Control hogar de Ancianos</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link as={Link} to="/home">Inicio</Nav.Link>
                            <Nav.Link as={Link} to="/home/create">Ingresar Adulto</Nav.Link>
                            <Nav.Link as={Link} to="/" ><span onClick={() =>signOut(auth)}>Salir</span></Nav.Link>
                                                        
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <section>
                <Outlet>

                </Outlet>

            </section>
        </>

    )
}
export default NavBar